import {
  FullStory,
  init as initFullStory,
  isInitialized as isFullStoryInitialized,
} from "@fullstory/browser"
import { segment } from "@/analytics/client"
import { $launchDarklyFlags } from "@/stores/launchDarkly"

type FullStoryReadyCallback = Parameters<typeof initFullStory>[1]

export const init = (onReady: FullStoryReadyCallback) => {
  if (isFullStoryInitialized()) {
    return
  }
  initFullStory({ orgId: "o-1XWVRD-na1", debug: true }, onReady)
}

const setFullStoryIdentity = (id: any, displayName: string, email: string) => {
  console.log("setIdentity")
  if (id) {
    FullStory("setIdentity", {
      uid: id,
      properties: {
        anonymousId: segment?.userInfo?.get()?.anonymousId,
        displayName,
        email,
        featureFlags: $launchDarklyFlags.get(),
      },
    })
  } else {
    FullStory("setProperties", {
      type: "user",
      properties: { featureFlags: $launchDarklyFlags.get() },
    })
  }
}

export const setFullStoryUser = (
  id: any,
  displayName: string,
  email: string
) => {
  if (isFullStoryInitialized()) {
    setFullStoryIdentity(id, displayName, email)
  } else {
    init(() => {
      setFullStoryIdentity(id, displayName, email)
    })
  }
}
